import { useEffect, useState } from 'react';
import { Breadcrumb, Card, Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../../../common/filter-table/Loading';
import { Private_Routes } from '../../../constants';
import { PayrollNoveltyFlowsForm } from '../components/forms/PayrollNoveltyFlowsForm';
import { usePayrollNoveltyFlows } from '../hooks/usePayrollNoveltyFlows';
import { PayrollNoveltyFlow } from '../models/payrollNoveltyFlow';

export const EditPayrollNoveltyFlows = () => {
    const { id } = useParams<{ id: string }>();

    const [payrollNoveltyFlow, setPayrollNoveltyFlow] =
        useState<PayrollNoveltyFlow | null>(null);

    const { getPayrollNoveltyFlow, isLoading } = usePayrollNoveltyFlows();

    useEffect(() => {
        if (id) {
            getPayrollNoveltyFlow(id)
                .then((res) => setPayrollNoveltyFlow(res))
                .catch((err) => toast.error(err.response.data));
        }
    }, [id]);

    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row '>
                        <div className='col-12 p-3 py-0'>
                            <Helmet>
                                <title>Editar flujos de aprobación</title>
                            </Helmet>

                            <Breadcrumb>
                                <Breadcrumb.Item href={Private_Routes.HOME}>
                                    Inicio
                                </Breadcrumb.Item>
                                <Breadcrumb.Item
                                    href={Private_Routes.PAYROLL_NOVELTY_FLOWS.index}
                                >
                                    Flujos de aprobación
                                </Breadcrumb.Item>
                                <Breadcrumb.Item
                                    href={Private_Routes.PAYROLL_NOVELTY_FLOWS.edit.replace(
                                        ':id',
                                        id ?? ''
                                    )}
                                >
                                    Editar flujo de aprobación
                                </Breadcrumb.Item>
                            </Breadcrumb>

                            <Row>
                                <Col sm={12}>
                                    <Card>
                                        <Card.Header>
                                            <div className='d-flex gap-2 justify-content-between align-items-center'>
                                                <h5>Editar flujo de aprobación</h5>
                                            </div>
                                        </Card.Header>

                                        <Card.Body>
                                            {isLoading && (
                                                <Loading
                                                    hasSkeleton={true}
                                                    skeletonType='table'
                                                />
                                            )}

                                            {!isLoading &&
                                                payrollNoveltyFlow != null && (
                                                    <PayrollNoveltyFlowsForm
                                                        isNew={false}
                                                        data={payrollNoveltyFlow}
                                                    />
                                                )}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
